import {Modal} from "antd";
import React, {useEffect, useState} from "react";
import {AppstoreOutlined} from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";
import SingleSelectGeneric from "../../piece/SingleSelectGeneric";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState({})
    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <AppstoreOutlined/> {props.modalTitle}
            </FilterButton>
            <Modal
                title= {props.modalTitle + ' Filter'}
                visible={visible}
                open={visible}
                onOk={() => {
                    if (value && props.onChange) {
                        let filterData = {}
                        for (const [key, val] of Object.entries(value)) {
                            let selection = props.selections.find(selection => selection['filterField'] === key)
                            filterData[key] = {
                                text: selection.filterLabel,
                                value: val
                            }
                        }
                        props.onChange(filterData)
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                {props.selections?.map((selection) => {
                      return (
                        <SingleSelectGeneric
                            key={selection.filterField}
                            placeholder={selection.filterLabel} 
                            selectoptions={selection.selectoptions}
                            defaultValue={defaultValue}
                            onChange={(newValue) => {
                                let obj = {}
                                obj[selection.filterField] = newValue
                                setValue({...value, ...obj})
                            }}                    
                        />
                      )
                })}               
            </Modal>
        </>
    )
}